import { FC } from 'react';
import { useAppSelector } from 'hooks/redux';
import {
  PLAN_RECOMMENDER_TITLE,
  PLAN_RECOMMENDER_SUBTITLE,
  PLAN_RECOMMENDER_SUBTITLE_2,
  GET_STARTED,
} from 'constants/languageConstants';
import { getText } from 'utils/stringUtil';
import iconClose from 'images/plan-recommender/icon-close.png';

import styles from './PlanRecommenderPopup.module.less';

type PlanRecommenderPopup = {
  closeModal: Function;
  clickStart: Function;
};

const PlanRecommenderPopup: FC<PlanRecommenderPopup> = ({
  closeModal,
  clickStart,
}: PlanRecommenderPopup) => {
  const language = useAppSelector((state) => state.benguide.data?.language);

  return (
    <div className={styles.planRecommenderModal}>
      <div className={styles.modalContentWrapper}>
        <div
          className={styles.closeIcon}
          onClick={() => {
            closeModal();
          }}
        >
          <img src={iconClose} alt="close" />
        </div>
        <div className={styles.titleWrapper}>
          <div className={styles.title}>
            {getText(PLAN_RECOMMENDER_TITLE, language)}
          </div>
          <div className={styles.subTitle}>
            {getText(PLAN_RECOMMENDER_SUBTITLE, language)}
            <br />
            {getText(PLAN_RECOMMENDER_SUBTITLE_2, language)}
          </div>

          <button
            className={styles.getStartedBtn}
            onClick={() => {
              clickStart();
            }}
          >
            {getText(GET_STARTED, language)}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlanRecommenderPopup;
